/*
 * Models for the sortable List
 */

define(["backbone"], function (Backbone) {
  var SortableListModel = {};

  SortableListModel.headerModel = Backbone.Model.extend({
    defaults: {
      checkbox: false,
      sortable: false,
      filterable: false,
      selectable: false,
      textField: false,
      numericField: false,
      dateField: false,
      durationField: false,
      hidden: false,
      hideable: false,
      defaultSort: false,
      escapeHTML: true,
      booleanField: false,
    },
  });

  SortableListModel.headerCollection = Backbone.Collection.extend({
    model: SortableListModel.headerModel,
  });

  return SortableListModel;
});
